import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  Label,
  FormFeedback,
  Form,
  Button,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import "./ecommerce.css";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import defaultProductImage from "../../assets/images/product-default.png";

import classnames from "classnames";
import Dropzone from "react-dropzone";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//formik
import { useFormik } from "formik";
import * as Yup from "yup";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import {
  listBrand,
  listCategory,
  listFeature,
  listSpeacification,
  listVariant,
  updateProduct,
  viewProduct,
  listRoute,
} from "./_requests";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { createSpecification } from "../../pages/Specification/_requests";
import { createVariant } from "../../pages/Variant/_requests";
import { createFeatures } from "../../pages/Features/_requests";
import { createCategory } from "../../pages/Category/_requests";
import { createBrand } from "../../pages/Brand/_requests";
import { useToast } from "../../Components/Common/ToastContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
interface FormattedData {
  variant: number;
  mrp: number;
  offer_value: number;
  offer_type: number;
  actual_amount: number;
  stock: number;
  sku: string;
}
type BrandOption = {
  label: any;
  value: any;
};
type CategoryOption = {
  label: any;
  value: any;
};
type SpecificationOption = {
  label: any;
  value: any;
};
type FeatureOption = {
  label: any;
  value: any;
};
interface Product {
  name?: string;
  billing_name?: string;
  short_description?: string;
  longDesc?: string;
  offerType?: number;
  offerValue?: number;
  category: number;
  brand: number;
  categoryId: number;
  brandId: number;
  width: number;
  weight: number;
  breath: number;
  length: number;
  hsn_code: string;
  publishStatus: number;
  cgst: number;
  sgst: number;
  igst: number;
  publishedDate: string;
  productDescription: string;
  visibility: number;
  variants: FormattedData[]; // Required: Array of variant data
  list_order: number;
  is_popular: number;
  is_new_arrival: number;
  is_subscription_available: boolean;
  route_slots?: any[];
}

interface FormattedData {
  id?: number;
  variant_id: number;
  variant_value: number;
  mrp: number;
  offer_value: number;
  offer_type: number;
  actual_amount: number;
  stock: number;
  sku: string;
  variant_code: string;
  route_slots: any[];
}

interface AvailableVariant {
  id: number;
  name: string;
}

interface VariantDetail {
  variant: number;
  value: number;
}

interface VariantData {
  [key: string]: any; // Dynamic keys for variant data
}

interface Result {
  variant: VariantDetail[];
  variantData: VariantData;
}

const EditProduct = () => {
  document.title = "Paal Dappa | Admin panel";
  const { userProfile } = useProfile();
  const { id } = useParams();
  const { showToast } = useToast();
  const history = useNavigate();
  const [product, setProduct] = useState<Product | null>(null); // Ensure product is not an array
  const [availableVariants, setAvailableVariants] = useState<any[]>([]);
  console.log("product", product)

  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: product?.name || "",
      billing_name: product?.billing_name || "",
      short_description: product?.short_description || "",
      productDescription: product?.longDesc || "",
      category: product?.categoryId || 0,
      brand: product?.brandId || 0,
      width: product?.width || 0,
      weight: product?.weight || 0,
      breath: product?.breath || 0,
      length: product?.length || 0,
      hsn_code: product?.hsn_code || "",
      publishStatus: product?.publishStatus || "",
      cgst: product?.cgst || 0,
      sgst: product?.sgst || 0,
      igst: product?.igst || 0,
      publishedDate: product?.publishedDate || "",
      visibility: product?.visibility || 0,
      list_order: product?.list_order || 0,
      is_popular: product?.is_popular === 1,
      is_new_arrival: product?.is_new_arrival === 1,
      is_subscription_available: product?.is_subscription_available === true,
      rating: (product as any)?.rating ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter a Product Name"),
      billing_name: Yup.string().required("Please Enter a Billing Name"),
      // short_description: Yup.string().required(
      //   "Please Enter a Short Description"
      // ),
      productDescription: Yup.string().required(
        "Please Enter a Product Description"
      ),
      category: Yup.string().required("Please Enter Product Category"),
      brand: Yup.string().required("Please Enter Product Brand"),
      hsn_code: Yup.string().required("Please Enter HSN Code"),
      publishStatus: Yup.number()
        .typeError("Please Select Status (Drafted, Published, and Scheduled)")
        .moreThan(0, "Please Select Status (Drafted, Published, and Scheduled)")
        .required("Please Select Status (Drafted, Published, and Scheduled)"),

      visibility: Yup.number()
        .typeError("Please Select Visibility (Public, Hidden)")
        .moreThan(0, "Please Select Visibility (Public, Hidden)")
        .required("Please Select Visibility (Public, Hidden)"),
      rating: Yup.number()
        .min(0, "Rating must be at least 0")
        .max(5, "Rating cannot exceed 5"),

      // cgst: Yup.number().required("Please Enter CGST").positive("CGST must be positive"),
      // sgst: Yup.number().required("Please Enter SGST").positive("SGST must be positive"),
      // igst: Yup.number().required("Please Enter IGST").positive("IGST must be positive"),
      // publishedDate: Yup.date().when("status", {
      //   is: (val: any) => val === "3",
      //   then: (schema) => schema.required("Please Select Publish Date"),
      // }),
      // productImage: Yup.mixed().required("Please upload a product image"),
      productGallery: Yup.array().min(
        1,
        "Please upload at least one gallery image"
      ),
      variantData: Yup.array()
        .of(
          Yup.object().shape({
            variant_id: Yup.number()
              .typeError("Please select a variant (ml, L, g, KG)")
              .moreThan(0, "Please select a variant (ml, L, g, KG)")
              .required("Please select a variant (ml, L, g, KG)"),
            variant_value: Yup.number()
              .typeError("Please enter a variant value, must be a number (Eg : 1 kg, 500 ML, 1L ..")
              .positive("variant value must be positive, must be a number")
              .moreThan(0, "Please enter a variant value (Eg : 1 kg, 500 ML, 1L ..")
              .required(
                "Please enter a variant value (Eg : 1 kg, 500 ML, 1L .. "
              ),
            offer_value: Yup.number()
              .when("offer_type", {
                is: (val: any) => !!val, // only validate if offer_type is truthy (not null/undefined/false/empty)
                then: (schema) =>
                  schema
                    .required("Please enter a offer value, must be a number")
                    .positive("Offer value must be positive, must be a number"),
                otherwise: (schema) => schema.notRequired(),
              }),

            mrp: Yup.number()
              .typeError("Please MRP of the product., must be a number")
              .moreThan(0, "Please MRP of the product, must be a number")
              .required("Please enter a MRP of the product Price, must be a number")
              .positive("Price must be positive"),
            // stock: Yup.number()
            //   .required("Please enter stock quantity")
            //   .positive("Stock quantity must be positive"),
            // skuId: Yup.string().required("Please enter a SKU ID"),
          })
        )
        .min(1, "Please add at least one variant"),
    }),

    onSubmit: async (values) => {
      const formData = new FormData();

      // Append simple fields (strings, numbers)
      formData.append("name", values.name);
      formData.append("billing_name", values.billing_name);
      formData.append("brand", values.brand.toString());
      formData.append("category", values.category.toString());
      formData.append("shortDescription", values.short_description);
      formData.append("productDescription", values.productDescription);
      formData.append("publishDate", values.publishedDate);
      formData.append("publishStatus", values.publishStatus.toString());
      formData.append("visibility", values.visibility.toString());
      formData.append("igst", values.igst.toString());
      formData.append("sgst", values.sgst.toString());
      formData.append("cgst", values.cgst.toString());
      formData.append("hsn_code", values.hsn_code);
      formData.append("width", values.width.toString());
      formData.append("weight", values.weight.toString());
      formData.append("length", values.length.toString());
      formData.append("breath", values.breath.toString());
      formData.append("updatedBy", userProfile.userId);
      formData.append("list_order", values.list_order.toString());
      formData.append("is_popular", values.is_popular ? "1" : "0");
      formData.append("is_new_arrival", values.is_new_arrival ? "1" : "0");
      formData.append("is_subscription_available", values.is_subscription_available ? "1" : "0");
      formData.append("rating", String(values.rating ?? 0));

      if (variantData.length > 0) {
        const processedVariantData = variantData.map(variant => ({
          ...variant,
          route_slots: variant.route_slots?.map((rs: any) => rs.value) || []
        }));
        formData.append("variantData", JSON.stringify(processedVariantData)); // Serialize the entire array as a JSON string
      }

      // Append specification data as a JSON string
      if (Array.isArray(specification) && specification.length > 0) {
        formData.append("specification", JSON.stringify(specification)); // Serialize the array as a JSON string
      }

      // Append feature data as a JSON string
      if (Array.isArray(feature) && feature.length > 0) {
        formData.append("feature", JSON.stringify(feature)); // Serialize the array as a JSON string
      }

      // Handle single file (productImage)
      if (selectedImage) {
        formData.append("productImage", selectedImage);
      }

      // Handle multiple files (productGallery)
      if (selectedFiles && selectedFiles.length > 0) {
        // Filter out existing images (those that have an ID)
        const existingImages = selectedFiles.filter((file: any) => file.id);

        // New files are those without an ID (newly uploaded)
        const newFiles = selectedFiles.filter((file: any) => !file.id);

        // Append existing images as IDs to FormData
        if (existingImages.length > 0) {
          const existingImageIds = existingImages?.map((image: any) => image.id);
          formData.append("existingImages", JSON.stringify(existingImageIds)); // Append as a JSON string of IDs
        } else {
          formData.append("existingImages", JSON.stringify([])); // 
        }

        // Append new files as actual files to FormData
        if (newFiles.length > 0) {
          newFiles.forEach((file: any) => {
            formData.append("productGallery", file); // Append each file
          });
        }
      }

      // Save new product
      const res: any = await updateProduct(formData, id);
      if (res.status === true) {
        showToast(res.message, res.status);
        validation.resetForm();
        history("/products");
      } else {
        showToast(res.message, res.status);
      }
    },
  });

  const dateFormat = (selectedDates: Date[]) => {
    // Ensure selectedDates is an array and has at least one date
    if (!Array.isArray(selectedDates) || selectedDates.length === 0) {
      return;
    }
    // Get the first selected date
    const dateString = selectedDates[0];
    // Parse the date string into a Date object
    const parsedDate = new Date(dateString);

    // Format the date to YYYY-MM-DDTHH:MM:SS format (ISO 8601 without timezone)
    const formattedDate = parsedDate.toISOString().split(".")[0]; // Removes the milliseconds and 'Z' (timezone)

    // Create a formatted date string
    // Set the formatted date in validation
    validation.setFieldValue("publishedDate", formattedDate);
  };
  // Example price options
  const priceOptions = [
    { value: 0, label: "Select Offer Type" },
    { value: 1, label: "Amount" },
    { value: 2, label: "Percentage" },
  ];
  useEffect(() => {
    listBrand().then((res: any) => {
      setAvailableBrand(res.data || []);
    });
    listSpeacification().then((res: any) => {
      setAvailableSpecification(res.data || []);
    });
    listVariant().then((res: any) => {
      setAvailableVariants(res.data || []);
    });
    console.log("availableVariants", availableVariants);
    listFeature().then((res: any) => {
      setAvailableFeature(res.data || []);
    });
    listCategory().then((res: any) => {
      setAvailableCategories(res.data || []);
    });
    listRoute().then((res: any) => {
      setAvailableRoutes(res.data || []);
    });
    viewProducts(id);
  }, []);
  // Function to retrieve dynamic variant and corresponding variantData
  const retrieveVariants = (
    formattedData: FormattedData[],
    availableVariants: AvailableVariant[]
  ): Result[] => {
    return formattedData?.map((item) => {
      // // Split the variant string into components
      // const variantParts = item.variant.split(",");

      // // Initialize an object to hold the retrieved data
      const retrieved: Result = {
        variant: [],
        variantData: {},
      };
      console.log("retrieved", retrieved)
      // // Use a Set to keep track of processed variant IDs and combinations
      // const processedVariantIds = new Set<string>();

      // // Loop through the variant parts to retrieve original values
      // variantParts.forEach((part) => {
      //   const [variantId, value] = part.split("-");
      //   const id = parseInt(variantId);

      //   // Create a unique key for the variant combination
      //   const variantKey = `${id}-${value}`;

      //   // Check if this variant combination has already been processed
      //   if (!processedVariantIds.has(variantKey)) {
      //     processedVariantIds.add(variantKey); // Mark this variant combination as processed

      //     // Find the matching available variant
      //     const availableVariant = availableVariants?.find((v) => v.id === id);
      //     if (availableVariant) {
      //       retrieved.variant.push({ variant: id, value: value });
      //     }
      //   }
      // });

      // // Build the variantData based on the retrieved variant values
      // retrieved.variant.forEach((v) => {
      //   const variantName = availableVariants?.find(
      //     (av) => av.id === v.variant
      //   )?.name; // Get the variant name
      //   if (variantName) {
      //     retrieved.variantData[variantName] = v.value; // Add to variantData
      //   }
      // });

      // Add relevant pricing and stock data from formattedData
      retrieved.variantData.id = item.id;
      retrieved.variantData.variant_id = item.variant_id;
      retrieved.variantData.variant_value = item.variant_value;
      retrieved.variantData.offer_type = item.offer_type;
      retrieved.variantData.offer_value = item.offer_value;
      retrieved.variantData.actual_amount = item.actual_amount;
      retrieved.variantData.mrp = item.mrp;
      retrieved.variantData.sku = item.sku;
      retrieved.variantData.variant_code = item.variant_code;
      retrieved.variantData.route_slots = item.route_slots?.map((rs: any) => ({
        label: rs.route?.name,
        value: rs.route_id,
      })) || [];

      return retrieved;
    });
  };
  useEffect(() => {
    const result = retrieveVariants(product?.variants ?? [], availableVariants);

    // Create a Set to track unique variants
    const uniqueVariants = new Set<string>();
    const filteredVariants = result.flatMap((r) => {
      return r.variant.filter((v) => {
        const variantKey = `${v.variant}-${v.value}`;
        if (!uniqueVariants.has(variantKey)) {
          uniqueVariants.add(variantKey);
          return true; // Keep this variant
        }
        return false; // Skip this variant
      });
    });

    // Set the state with the retrieved data
    setVariantData(result?.map((r) => r.variantData)); // Set variantData state
    setVariant(filteredVariants); // Set variants state without duplicates

    // Check the state after setting
    console.log(
      "Variant Data State:",
      result?.map((r) => r.variantData)
    );
    console.log("Variants State:", filteredVariants);
  }, [availableVariants, product]);

  const viewProducts = async (id: any) => {
    try {
      const res: any = await viewProduct(id); // Replace with your actual API call

      // const tagsArray = res.data?.tags
      //   ?.split(",")
      //   .map((tag: any) => tag.trim());
      const tagsArray = res.data?.tags
        ?.split(",")
        .map((tag: any) => tag.trim())
        .filter((tag: string) => tag.length > 0); // Remove empty tags
      console.log("res.data viewProducts state", res.data)
      // Set product-related state
      setProduct(res.data);
      setPreviewImage(res.data.icon);
      setFeature(res.data?.features || [{ feature: "", value: "" }]);
      setSpecification(res.data?.specifications || [{ specification: 0, value: "" }]);
      // Function to fetch file size and type from an image URL
      const getFileSizeAndTypeFromImage = async (
        url: string
      ): Promise<{ size: number; type: string }> => {
        const response = await fetch(url);
        const blob = await response.blob(); // Get the image as a Blob
        const fileType = blob.type; // Get the MIME type from the Blob
        return { size: blob.size, type: fileType }; // Return size and type
      };

      // Process galleries and fetch file sizes and types
      const updatedGalleries = await Promise.all(
        res.data?.galleries?.map(async (file: any) => {
          const id = file.id;
          const fileName = file.icon.split("product/")[1]; // Extract filename
          const { size: fileSize, type: fileType } =
            await getFileSizeAndTypeFromImage(file.icon); // Fetch size and type dynamically
          return {
            id,
            name: fileName,
            preview: file.icon,
            formattedSize: formatBytes(fileSize), // Format the file size properly
            type: fileType, // Add the file type to the returned object
          };
        })
      );

      // Set galleries with updated file size
      setSelectedFiles(updatedGalleries);
    } catch (error) {
      console.error("Error viewing product:", error);
    }
  };

  const [customActiveTab, setcustomActiveTab] = useState<any>("1");

  const toggleCustom = (tab: any) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [isBrandModal, setIsBrandModal] = useState(false);
  const [newBrand, setNewBrand] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [BrandError, setBrandError] = useState("");

  const [availableBrand, setAvailableBrand] = useState<any[]>([]);
  const [availableRoutes, setAvailableRoutes] = useState<any[]>([]);

  const handleBrand = async () => {
    if (newBrand.trim() === "") {
      setBrandError("Please enter a brand name.");
      return;
    }

    const formData = new FormData();
    formData.append("name", newBrand.trim());
    if (selectedBrandImage) {
      formData.append("icon", selectedBrandImage);
    }
    formData.append("created_by", userProfile?.userId);
    await createBrand(formData).then((res: any) => {
      if (res.status === true) {
        toast.success(res.message, { autoClose: 3000 });
        listBrand().then((res: any) => {
          setAvailableBrand(res.data);
        });
        // Reset modal state
        setNewBrand("");
        setBrandError("");
        setIsBrandModal(false);
      } else {
        toast.error(res.message, { autoClose: 3000 });
      }
    });
  };
  const toggleBrandModal = () => setIsBrandModal(!isBrandModal);

  const [previewBrandImage, setPreviewBrandImage] = useState<string | null>(
    null
  ); // Image preview
  const [selectedBrandImage, setSelectedBrandImage] = useState<File | null>(
    null
  ); // Selected image



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newVariant, setNewVariant] = useState("");
  const [varaiantError, setVaraiantError] = useState("");

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleSave = async () => {
    if (newVariant.trim()) {
      const data = {
        name: newVariant,
        created_by: userProfile.userId,
      };
      await createVariant(data).then((res: any) => {
        if (res.status === true) {
          toast.success(res.message, { autoClose: 3000 });
          listVariant().then((res: any) => {
            setAvailableVariants(res.data);
          });
          setIsModalOpen(false);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      });
    } else {
      setVaraiantError("Please enter a variant name.");
    }
  };

  const [variant, setVariant] = useState<VariantDetail[]>([]); // Ensure `variant` is initialized as an empty string
  const [variantData, setVariantData] = useState<any[]>([]); // Store the variant combinations

  const [isSpecificationModal, setIsSpecificationModal] = useState(false);
  const [specification, setSpecification] = useState([
    { specification: 0, value: "" },
  ]);
  const [newSpecification, setNewSpecification] = useState("");
  const [specificationError, setSpecificationError] = useState("");
  const [selectedParentSpecification, setSelectedParentSpecification] =
    useState<SpecificationOption | null>(null);
  const [availableSpecification, setAvailableSpecification] = useState<any[]>(
    []
  );

  const handleSpecification = async () => {
    if (newSpecification.trim() === "") {
      setSpecificationError("Please enter a Specification name.");
      return;
    }

    // Save logic for Specification and parent Specification (e.g., update the available Specification)
    const data = {
      name: newSpecification,
      specification_id: selectedParentSpecification
        ? selectedParentSpecification.value
        : null,
      created_by: userProfile?.userId,
    };
    await createSpecification(data).then((res: any) => {
      if (res.status === true) {
        toast.success(res.message, { autoClose: 3000 });
        listSpeacification().then((res: any) => {
          setAvailableSpecification(res.data);
        });
        // Reset modal state
        setNewSpecification("");
        setSelectedParentSpecification(null);
        setSpecificationError("");
        setIsSpecificationModal(false);
      } else {
        toast.error(res.message, { autoClose: 3000 });
      }
    });
  };

  const toggleSpecificationModal = () =>
    setIsSpecificationModal(!isSpecificationModal);

  const handleSpecificationAddRow = () => {
    const lastSpecification = specification[specification.length - 1];
    // Add a new row with the same variant value as the last selected variant
    setSpecification([
      ...specification,
      { specification: lastSpecification.specification, value: "" },
    ]);
  };

  const handleSpecificationRemoveRow = (index: any) => {
    const updatedRows = specification.filter((_, i) => i !== index);
    setSpecification(updatedRows);
  };

  const handleSpecificationChange = (index: any, field: any, newValue: any) => {
    const updatedRows = specification?.map((row, i) =>
      i === index ? { ...row, [field]: newValue } : row
    );
    setSpecification(updatedRows);
  };
  const [isFeatureModal, setIsFeatureModal] = useState(false);
  const [feature, setFeature] = useState([{ feature: "", value: "" }]);
  const [newFeature, setNewFeature] = useState("");
  const [featureError, setFeatureError] = useState("");
  const [selectedParentFeature, setSelectedParentFeature] =
    useState<FeatureOption | null>(null);
  const [availableFeature, setAvailableFeature] = useState<any[]>([]);

  const handleFeature = async () => {
    if (newFeature.trim() === "") {
      setFeatureError("Please enter a Feature name.");
      return;
    }

    // Save logic for Feature and parent Feature (e.g., update the available Feature)
    const data = {
      name: newFeature,
      feature_id: selectedParentFeature ? selectedParentFeature.value : null,
      created_by: userProfile.userId,
    };

    await createFeatures(data).then((res: any) => {
      if (res.status === true) {
        toast.success(res.message, { autoClose: 3000 });
        listFeature().then((res: any) => {
          setAvailableFeature(res.data);
        });
        // Reset modal state
        setNewFeature("");
        setSelectedParentFeature(null);
        setFeatureError("");
        setIsFeatureModal(false);
      } else {
        toast.error(res.message, { autoClose: 3000 });
      }
    });
  };
  const toggleFeatureModal = () => setIsFeatureModal(!isFeatureModal);

  const handleFeatureAddRow = () => {
    const lastFeature = feature[feature.length - 1];
    // Add a new row with the same Feature value as the last selected Feature
    setFeature([...feature, { feature: lastFeature.feature, value: "" }]);
  };

  const handleFeatureRemoveRow = (index: any) => {
    const updatedRows = feature.filter((_, i) => i !== index);
    setFeature(updatedRows);
  };

  const handleFeatureChange = (index: any, field: any, newValue: any) => {
    const updatedRows = feature?.map((row, i) =>
      i === index ? { ...row, [field]: newValue } : row
    );
    setFeature(updatedRows);
  };

  const [isCategoryModal, setIsCategoryModal] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [categoryError, setCategoryError] = useState("");

  const [selectedParentCategory, setSelectedParentCategory] =
    useState<CategoryOption | null>(null);
  const [availableCategories, setAvailableCategories] = useState<any[]>([]);

  const handleCategory = async () => {
    if (newCategory.trim() === "") {
      setCategoryError("Please enter a category name.");
      return;
    }

    // Save logic for category and parent category (e.g., update the available categories)
    const data = {
      name: newCategory,
      category_id: selectedParentCategory ? selectedParentCategory.value : null,
      created_by: userProfile.userId,
    };

    await createCategory(data).then((res: any) => {
      if (res.status === true) {
        toast.success(res.message, { autoClose: 3000 });
        listCategory().then((res: any) => {
          setAvailableCategories(res.data);
        });
        // Reset modal state
        setNewCategory("");
        setSelectedParentCategory(null);
        setCategoryError("");
        setIsCategoryModal(false);
      } else {
        toast.error(res.message, { autoClose: 3000 });
      }
    });
  };
  const toggleCategoryModal = () => setIsCategoryModal(!isCategoryModal);

  // const handleAddRow = () => {

  //   const lastVariant = variant[variant.length - 1];
  //   // Add a new row with the same variant value as the last selected variant
  //   setVariant([...variant, { variant: lastVariant.variant, value: 0 }]);
  // };
  const handleAddRow = () => {
    if (!variantData || !Array.isArray(variantData)) {
      console.error("variantData is not initialized or is not an array");
      return;
    }

    // Add a new row with the default structure
    const newRow = {
      id: 0,
      variant_id: 0,
      variant_value: 0,
      offer_type: 0,
      offer_value: 0,
      actual_amount: 0,
      mrp: 0,
      stock: 0,
      sku: "",
      variant_code: "",
      route_slots: [],
    };

    setVariantData([...variantData, newRow]); // Update the state with the new row
  };
  const handleRemoveRow = (index: any) => {
    const updatedRows = variantData.filter((_: any, i: number) => i !== index);
    setVariantData(updatedRows);
  };

  const handleCategoryChange = (index: any, field: any, newValue: any) => {
    const updatedRows = variant?.map((row, i) =>
      i === index ? { ...row, [field]: newValue } : row
    );
    setVariant(updatedRows);
  };

  const handleAcceptedFiles = (files: any) => {
    const updatedFiles = files?.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );

    const totalFiles = selectedFiles.length + updatedFiles.length;

    if (totalFiles > 10) {
      const allowedFilesCount = 10 - selectedFiles.length;
      const filesToAdd = updatedFiles.slice(0, allowedFilesCount);

      // Show a toast notification for exceeding the limit
      toast.warn(`You can only upload up to 10 files.`);

      setSelectedFiles((prevFiles: any) => [...prevFiles, ...filesToAdd]);
    } else {
      setSelectedFiles((prevFiles: any) => [...prevFiles, ...updatedFiles]);
    }
  };

  const removeFile = (index: number) => {
    setSelectedFiles((prevFiles: any[]) => {
      // Create a shallow copy of the array and remove the file at the given index
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1); // Remove the file at the specific index
      return updatedFiles;
    });
  };

  useEffect(() => {
    //Remember to revoke the object URLs when you are done with them to avoid memory leaks:
    return () => {
      selectedFiles.forEach((file: any) => {
        if (file.preview) {
          URL.revokeObjectURL(file.preview); // Clean up
        }
      });
    };
  }, [selectedFiles]);
  console.log("selectedFiles", selectedFiles);

  /**
   * Formats the size
   */
  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const productStatus = [
    {
      options: [
        { label: "Select Publish status", value: 0 },
        { label: "Draft", value: 1 },
        { label: "Published", value: 2 },
        { label: "Scheduled", value: 3 },
      ],
    },
  ];

  const productVisibility = [
    {
      options: [
        { label: "Select product visibility", value: "" },
        { label: "Hidden", value: 1 },
        { label: "Public", value: 2 },
      ],
    },
  ];

  // image
  const [selectedImage, setSelectedImage] = useState<any>();
  const [previewImage, setPreviewImage] = useState<any>(null); // Image preview
  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    field: any
  ) => {
    const files = event.target.files;
    if (files && files[0]) {
      const file = files[0];

      // Store the file object in state
      field === "formImage" && setSelectedImage(file);
      field === "modalImage" && setSelectedBrandImage(file);

      // Optional: Generate a base64 preview (for image preview purposes)
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && e.target.result) {
          field === "formImage" && setPreviewImage(e.target.result as string); // Store the base64 string for preview
          field === "modalImage" &&
            setPreviewBrandImage(e.target.result as string); // Store the base64 string for preview
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: "38px", // Customize the height to match Bootstrap's Input height
    }),
  };

  // Custom Quill modules for toolbar
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Header
      [{ font: [] }], // Font family
      [{ size: ["small", false, "large", "huge"] }], // Font size
      [{ color: [] }, { background: [] }], // Text color and background
      ["bold", "italic", "underline"], // Text style
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ align: [] }], // Alignment
      ["link", "image"], // Insert links or images
      ["clean"], // Clear formatting
    ],
  };

  // Formats allowed by ReactQuill
  const quillFormats = [
    "header",
    "font",
    "size",
    "color",
    "background",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "align",
    "link",
    "image",
  ];
  const scrollToError = (errors: any) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      const errorElement = document.querySelector(`[name="${errorFields[0]}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };
  const scrollToArrayError = (errors: any) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      const errorElement = document.querySelector(`[name="${errorFields[0]}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        // Handle nested array errors
        for (const field of errorFields) {
          if (Array.isArray(errors[field])) {
            const nestedErrorElement = document.querySelector(`[name="${field}[0]"]`);
            if (nestedErrorElement) {
              nestedErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
              break;
            }
          }
        }
      }
    }
  };
  type VariantDataType = {
    id?: number;
    variant_id: number;
    variant_value: number | string;
    offer_type: number;
    offer_value: number;
    mrp: number;
    actual_amount: number;
    stock: number;
    sku: string;
    route_slots: any[];
  };
  type VariantField = keyof VariantDataType;

  const handleCombinationChange = (
    index: number,
    field: keyof VariantDataType,
    value: any
  ) => {
    console.log("▶️ handleCombinationChange called", { index, field, value });

    // Create a copy of the current variant data
    const updatedVariantData = [...variantData];
    const currentRow = { ...updatedVariantData[index] };

    // Update the changed field first
    (currentRow as any)[field] = value;

    // Parse numeric fields to numbers
    const mrp = Number(currentRow.mrp) || 0;
    const offerValue = Number(currentRow.offer_value) || 0;
    const offerType = Number(currentRow.offer_type) || 0;
    let actualAmount = Number(currentRow.actual_amount) || 0;

    // Handle different field changes
    if (field === "variant_id") {
      // When variant_id changes, update variant_value from availableVariants
      const selectedVariant = availableVariants?.find(
        (variant) => variant.id === Number(value)
      );
      // if (selectedVariant) {
      //   currentRow.variant_value = selectedVariant.name;
      // }
    }
    else if (field === "offer_type" || field === "offer_value" || field === "mrp") {
      // Recalculate based on current values with bounds checking
      if (offerType === 1) { // Fixed amount
        if (offerValue > mrp) {
          toast.error(`Offer amount cannot exceed MRP (${mrp})`);
          currentRow.offer_value = mrp;
          currentRow.actual_amount = 0;
        } else {
          currentRow.actual_amount = Number((mrp - offerValue).toFixed(2));
        }
      } else if (offerType === 2) { // Percentage
        if (offerValue > 100) {
          toast.error("Offer percentage cannot exceed 100%");
          currentRow.offer_value = 100;
          currentRow.actual_amount = 0;
        } else {
          currentRow.actual_amount = Number((mrp - (mrp * (offerValue / 100))).toFixed(2));
        }
      } else { // No offer
        currentRow.actual_amount = mrp;
        currentRow.offer_value = 0;
      }
    }
    else if (field === "actual_amount") {
      // When actual amount changes directly, recalculate offer value
      if (offerType === 1) { // Fixed amount
        if (actualAmount > mrp) {
          toast.error(`Selling price cannot exceed MRP (${mrp})`);
          currentRow.actual_amount = mrp;
          currentRow.offer_value = 0;
        } else {
          currentRow.offer_value = Number((mrp - actualAmount).toFixed(2));
        }
      } else if (offerType === 2) { // Percentage
        if (actualAmount > mrp) {
          toast.error(`Selling price cannot exceed MRP (${mrp})`);
          currentRow.actual_amount = mrp;
          currentRow.offer_value = 0;
        } else {
          const discountPercent = mrp > 0 ? ((mrp - actualAmount) / mrp) * 100 : 0;
          currentRow.offer_value = Number(discountPercent.toFixed(2));
        }
      }
    }

    // Update the row in the array
    updatedVariantData[index] = currentRow;

    // Update both local state and formik state
    setVariantData(updatedVariantData);
    validation.setFieldValue("variantData", updatedVariantData);

    console.log("Updated variant data:", updatedVariantData);
  };

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumb title="Update Product" pageTitle="Paal Dappa" />
        <Form
          onSubmit={validation.handleSubmit}
        >
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="product-title-input">
                      Product Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="product-title-input"
                      placeholder="Enter product Name"
                      name="name"
                      value={validation.values.name || ""}
                      onBlur={validation.handleBlur}
                      onChange={(e) => {
                        validation.handleChange(e);
                        const currentName = validation.values.name || "";
                        const currentBillingName = validation.values.billing_name || "Paal Dappa - ";
                        if (currentBillingName === "Paal Dappa - " || currentBillingName === `Paal Dappa - ${currentName}`) {
                          validation.setFieldValue("billing_name", `Paal Dappa - ${e.target.value}`);
                        }
                      }}
                      invalid={
                        validation.errors.name && validation.touched.name
                          ? true
                          : false
                      }
                    />
                    {validation.errors.name && validation.touched.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="billing-name-input">
                      Billing Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="billing-name-input"
                      placeholder="Enter Billing Name"
                      name="billing_name"
                      value={validation.values.billing_name || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={
                        validation.errors.billing_name && validation.touched.billing_name
                          ? true
                          : false
                      }
                    />
                    {validation.errors.billing_name && validation.touched.billing_name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.billing_name}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div>
                    <Label>Product Description <span className="text-danger">*</span></Label>
                    <ReactQuill
                      theme="snow"
                      value={validation.values.productDescription}
                      onChange={(value: any) => validation.setFieldValue("productDescription", value)}
                      modules={quillModules}
                      formats={quillFormats}
                    />
                    {validation.errors.productDescription && validation.touched.productDescription ? (
                      <FormFeedback type="invalid">
                        {validation.errors.productDescription}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>

              <Card className="pb-4">
                <CardHeader>
                  <h5 className="card-title mb-0">Product Gallery </h5>
                </CardHeader>
                <CardBody>
                  <div className="mb-4">
                    <h5 className="fs-14 mb-1">Product Image <span className="text-danger">*</span></h5>
                    <p className="text-muted">Edit Product main Image.</p>
                    <div className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="position-absolute top-100 start-100 translate-middle">
                          <Label
                            htmlFor="brand-image-input"
                            className="mb-0"
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            title="Select Image"
                          >
                            <div className="avatar-xs cursor-pointer">
                              <div className="avatar-title bg-light border rounded-circle text-muted">
                                <i className="ri-image-fill"></i>
                              </div>
                            </div>
                          </Label>
                          <Input
                            name="formImage"
                            className="form-control d-none"
                            id="brand-image-input"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => handleImageChange(e, "formImage")}
                            invalid={
                              validation.touched.image &&
                                validation.errors.image
                                ? true
                                : false
                            }
                          />
                        </div>
                        <div className="avatar-lg">
                          <div className="avatar-title bg-light rounded">
                            <img
                              src={previewImage}
                              id="product-img"
                              alt=""
                              className="avatar-md h-auto"
                            />
                          </div>
                        </div>
                      </div>
                      {validation.errors.image && validation.touched.image ? (
                        <FormFeedback type="invalid">
                          {" "}
                          {validation.errors.image}{" "}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </div>
                  <div></div>
                  <h5 className="fs-14 mb-1">Product Gallery</h5>
                  <p className="text-muted">Edit Product Gallery Images.</p>

                  <Dropzone
                    onDrop={(acceptedFiles) => {
                      handleAcceptedFiles(acceptedFiles);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone dz-clickable">
                        <div
                          className="dz-message needsclick"
                          {...getRootProps()}
                        >
                          <div className="mb-3 mt-5">
                            <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                          </div>
                          <h5>Drop files here or click to upload.</h5>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <div className="list-unstyled mb-0" id="file-previews">
                    <div className="list-unstyled mb-0" id="file-previews">
                      {selectedFiles?.map((file: any, index: number) => (
                        <Card
                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                          key={index + "-file"}
                        >
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={file.name}
                                  src={
                                    file?.preview &&
                                      file?.type?.startsWith("video/")
                                      ? defaultProductImage // Use a default video thumbnail for video files
                                      : file.preview || defaultProductImage // Use preview or default product image
                                  }
                                />
                              </Col>
                              <Col>
                                <Link
                                  to="#"
                                  className="text-muted font-weight-bold"
                                >
                                  {file.name}
                                </Link>
                                <p className="mb-0">
                                  <strong>{file.formattedSize}</strong>
                                </p>
                              </Col>
                              <Col className="col-auto">
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => removeFile(index)}
                                >
                                  Remove
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={4}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Product Brand <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    {" "}
                    <Link
                      to="#"
                      className="float-end text-decoration-underline"
                      onClick={toggleBrandModal}
                    >
                      Add New
                    </Link>
                    Select product Brand
                  </p>

                  <select
                    className={`form-control ${validation.errors.brand && validation.touched.brand
                      ? "is-invalid"
                      : ""
                      }`}
                    id="price-select"
                    name="brand"
                    aria-placeholder="select offer type"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.brand}
                  >
                    <option value="">Select Brand</option>
                    {availableBrand?.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>

                  {validation.touched.brand && validation.errors.brand ? (
                    <FormFeedback type="invalid">
                      {validation.errors.brand}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Product Category <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    {" "}
                    <Link
                      to="#"
                      className="float-end text-decoration-underline"
                      onClick={toggleCategoryModal}
                    >
                      Add New
                    </Link>
                    Select product category
                  </p>

                  <select
                    className={`form-control ${validation.errors.category && validation.touched.category
                      ? "is-invalid"
                      : ""
                      }`}
                    id="price-select"
                    name="category"
                    aria-placeholder="select offer type"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.category}
                  >
                    <option value="">Select Category</option>
                    {availableCategories?.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>

                  {validation.touched.category && validation.errors.category ? (
                    <FormFeedback type="invalid">
                      {validation.errors.category}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>





              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Product Short Description</h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    Add short description for product
                  </p>
                  <textarea
                    className="form-control"
                    placeholder="Must enter minimum of a 100 characters"
                    value={validation.values.short_description}
                    onChange={(e) =>
                      validation.setFieldValue(
                        "short_description",
                        e.target.value
                      )
                    }
                    rows={3}
                  ></textarea>
                  {validation.errors.short_description && validation.touched.short_description ? (
                    <FormFeedback type="invalid">
                      {validation.errors.short_description}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Product Config</h5>
                </CardHeader>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="listing-order-input">
                      Listing Order
                    </Label>
                    <Input
                      type="number"
                      className="form-control"
                      id="listing-order-input"
                      placeholder="Enter listing order"
                      name="list_order"
                      value={validation.values.list_order || 0}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                    />
                  </div>
                  <div className="form-check form-switch mb-3">
                    <Input
                      type="switch"
                      className="form-check-input"
                      id="is-popular-switch"
                      name="is_popular"
                      checked={validation.values.is_popular}
                      onChange={validation.handleChange}
                    />
                    <Label className="form-check-label" htmlFor="is-popular-switch">
                      Is Popular
                    </Label>
                  </div>
                  <div className="form-check form-switch mb-3">
                    <Input
                      type="switch"
                      className="form-check-input"
                      id="is-new-arrivals-switch"
                      name="is_new_arrival"
                      checked={validation.values.is_new_arrival}
                      onChange={validation.handleChange}
                    />
                    <Label className="form-check-label" htmlFor="is-new-arrivals-switch">
                      Is New Arrivals
                    </Label>
                  </div>
                  <div className="form-check form-switch mb-3">
                    <Input
                      type="switch"
                      className="form-check-input"
                      id="is-subscription-available-switch"
                      name="is_subscription_available"
                      checked={validation.values.is_subscription_available}
                      onChange={validation.handleChange}
                    />
                    <Label className="form-check-label" htmlFor="is-subscription-available-switch">
                      Is Subscription Available
                    </Label>
                  </div>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="edit-average-ratings-input">
                      Average Ratings
                    </Label>
                    <Input
                      type="number"
                      className="form-control"
                      id="edit-average-ratings-input"
                      placeholder="0.00"
                      name="rating"
                      value={validation.values.rating ?? ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={
                        validation.errors.rating && validation.touched.rating
                          ? true
                          : false
                      }
                      step="0.01"
                      min="0"
                      max="5"
                    />
                    {validation.errors.rating && validation.touched.rating ? (
                      <FormFeedback type="invalid">
                        {validation.errors.rating}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Publish <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <div className="mb-3">
                    <Label
                      htmlFor="choices-publish-status-input"
                      className="form-label"
                    >
                      Publish Status
                    </Label>
                    <select
                      className={`form-control ${validation.errors.publishStatus && validation.touched.publishStatus
                        ? "is-invalid"
                        : ""
                        }`}
                      disabled
                      id="price-select"
                      name="publishStatus"
                      aria-placeholder="select offer type"
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      value={validation.values.publishStatus}
                    >
                      {productStatus?.map((item, key) => (
                        <React.Fragment key={key}>
                          {item.options?.map((item, key) => (
                            <option value={item.value} key={key}>
                              {item.label}
                            </option>
                          ))}
                        </React.Fragment>
                      ))}
                    </select>
                    {validation.touched.publishStatus && validation.errors.publishStatus ? (
                      <FormFeedback type="invalid">
                        {validation.errors.publishStatus}
                      </FormFeedback>
                    ) : null}
                  </div>
                  {validation.values.publishStatus == 3 && (
                    <div>
                      <label
                        htmlFor="datepicker-publish-input"
                        className="form-label"
                      >
                        Publish Date & Time
                      </label>
                      <Flatpickr
                        name="publishedDate"
                        id="publishedDate-field"
                        className="form-control"
                        placeholder="Select a date"
                        options={{
                          enableTime: true,
                          altInput: true,
                          altFormat: "d M, Y, h:i K",
                          dateFormat: "d M, Y, h:i K",
                          minDate: "today", // Restrict to current date and future
                        }}
                        onChange={(selectedDates) => dateFormat(selectedDates)}
                        value={validation.values.publishedDate || ""}
                      />
                      {validation.touched.publishedDate &&
                        validation.errors.publishedDate ? (
                        <FormFeedback type="invalid">
                          {validation.errors.publishedDate}
                        </FormFeedback>
                      ) : null}
                    </div>
                  )}
                  <div className="mb-3">
                    <Label
                      htmlFor="choices-publish-visibility-input"
                      className="form-label"
                    >
                      Visibility <span className="text-danger">*</span>
                    </Label>

                    <select
                      className={`form-control ${validation.errors.visibility && validation.touched.visibility
                        ? "is-invalid"
                        : ""
                        }`}
                      id="visibility"
                      name="visibility"
                      aria-placeholder="select offer type"
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      value={validation.values.visibility}
                    >
                      {productVisibility?.map((item, key) => (
                        <React.Fragment key={key}>
                          {item.options?.map((item, key) => (
                            <option value={item.value} key={key}>
                              {item.label}
                            </option>
                          ))}
                        </React.Fragment>
                      ))}
                    </select>

                    {validation.touched.visibility && validation.errors.visibility ? (
                      <FormFeedback type="invalid">
                        {validation.errors.visibility}
                      </FormFeedback>
                    ) : null}
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <Nav className="nav-tabs-custom card-header-tabs border-bottom-0">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        Tax & Configuration
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "3",
                        })}
                        onClick={() => {
                          toggleCustom("3");
                        }}
                      >
                        Specifications
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "4",
                        })}
                        onClick={() => {
                          toggleCustom("4");
                        }}
                      >
                        Features
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "5",
                        })}
                        onClick={() => {
                          toggleCustom("5");
                        }}
                      >
                        Variant (Route Base)
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>

                <CardBody>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="1">
                      <Row></Row>
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="hsn-code-input"
                            >
                              HSN Code <span className="text-danger">*</span>
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="hsn-code-input"
                              name="hsn_code"
                              placeholder="Enter HSN code"
                              value={validation.values.hsn_code || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={
                                validation.errors.hsn_code &&
                                  validation.touched.hsn_code
                                  ? true
                                  : false
                              }
                            />
                            {validation.errors.hsn_code &&
                              validation.touched.hsn_code ? (
                              <FormFeedback type="invalid">
                                {validation.errors.hsn_code}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="hsn-code-input"
                            >
                              IGST
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="hsn-code-input"
                              name="igst"
                              placeholder="Enter igst percentage"
                              value={validation.values.igst || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={
                                validation.errors.igst &&
                                  validation.touched.igst
                                  ? true
                                  : false
                              }
                            />
                            {validation.errors.igst &&
                              validation.touched.igst ? (
                              <FormFeedback type="invalid">
                                {validation.errors.igst}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="hsn-code-input"
                            >
                              CGST
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="hsn-code-input"
                              name="cgst"
                              placeholder="Enter cgst percentage"
                              value={validation.values.cgst || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={
                                validation.errors.cgst &&
                                  validation.touched.cgst
                                  ? true
                                  : false
                              }
                            />
                            {validation.errors.cgst &&
                              validation.touched.cgst ? (
                              <FormFeedback type="invalid">
                                {validation.errors.cgst}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="hsn-code-input"
                            >
                              SGST
                            </label>
                            <Input
                              type="text"
                              className="form-control"
                              id="hsn-code-input"
                              name="sgst"
                              placeholder="Enter sgst percentage"
                              value={validation.values.sgst || ""}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={
                                validation.errors.sgst &&
                                  validation.touched.sgst
                                  ? true
                                  : false
                              }
                            />
                            {validation.errors.sgst &&
                              validation.touched.sgst ? (
                              <FormFeedback type="invalid">
                                {validation.errors.sgst}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="3">
                      <Row>
                        <FormGroup>
                          <p className="mb-2 col-lg-4">
                            {" "}
                            <Link
                              to="#"
                              className="float-end text-decoration-underline"
                              onClick={toggleSpecificationModal}
                            >
                              Add New
                            </Link>
                            Product Specifications
                          </p>
                          <TransitionGroup>
                            {specification?.map((row, index) => (
                              <CSSTransition
                                key={index}
                                timeout={300}
                                classNames="variant-row"
                              >
                                <Row className="mb-2 align-items-center">
                                  <Col lg={4}>
                                    <Select
                                      className="mb-2"
                                      value={{
                                        label:
                                          availableSpecification?.find(
                                            (spec) =>
                                              spec.id === row.specification // Change from `value` to `id`
                                          )?.name || "", // Use the correct label here
                                        value: row.specification,
                                      }}
                                      onChange={(selectedOption: any) => {
                                        handleSpecificationChange(
                                          index,
                                          "specification",
                                          selectedOption?.value // Use `value` from selected option
                                        );
                                      }}
                                      options={availableSpecification?.map(
                                        (spec) => ({
                                          label: spec.name,
                                          value: spec.id,
                                        })
                                      )}
                                      placeholder="Select Specification"
                                      styles={customStyles} // Optional: custom styles to match Bootstrap Input styling
                                    />
                                  </Col>
                                  <Col lg={4}>
                                    <Input
                                      type="text"
                                      className="mb-2"
                                      placeholder="Enter value"
                                      value={row.value}
                                      onChange={(e) =>
                                        handleSpecificationChange(
                                          index,
                                          "value",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col lg={4}>
                                    <Button
                                      color="primary"
                                      className="me-2"
                                      onClick={handleSpecificationAddRow}
                                      disabled={
                                        index !== specification.length - 1
                                      }
                                    >
                                      +
                                    </Button>

                                    {specification.length > 1 && (
                                      <Button
                                        color="danger"
                                        onClick={() =>
                                          handleSpecificationRemoveRow(index)
                                        }
                                      >
                                        Remove
                                      </Button>
                                    )}
                                  </Col>
                                </Row>
                              </CSSTransition>
                            ))}
                          </TransitionGroup>
                        </FormGroup>
                      </Row>
                    </TabPane>
                  </TabContent>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="4">
                      <Row>
                        <FormGroup>
                          <p className="mb-2 col-lg-4">
                            <Link
                              to="#"
                              className="float-end text-decoration-underline"
                              onClick={toggleFeatureModal}
                            >
                              Add New
                            </Link>
                            Product Feature
                          </p>
                          <TransitionGroup>
                            {feature?.map((row, index) => (
                              <CSSTransition
                                key={index}
                                timeout={300}
                                classNames="variant-row"
                              >
                                <Row className="mb-2 align-items-center">
                                  <Col lg={4}>
                                    <Select
                                      className="mb-2"
                                      value={{
                                        label:
                                          availableFeature?.find(
                                            (feat) => feat.id === row.feature // Change from `feature.value` to `feat.id`
                                          )?.name || "", // Use the correct property for the label
                                        value: row.feature,
                                      }}
                                      onChange={(selectedOption: any) => {
                                        handleFeatureChange(
                                          index,
                                          "feature",
                                          selectedOption?.value // Ensure selected value is passed correctly
                                        );
                                      }}
                                      options={availableFeature?.map((feat) => ({
                                        label: feat.name,
                                        value: feat.id,
                                      }))}
                                      placeholder="Select Feature"
                                      styles={customStyles} // Optional: custom styles to match Bootstrap Input styling
                                    />
                                  </Col>
                                  <Col lg={4}>
                                    <Input
                                      type="text"
                                      className="mb-2"
                                      placeholder="Enter value"
                                      value={row.value}
                                      onChange={(e) =>
                                        handleFeatureChange(
                                          index,
                                          "value",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col lg={4}>
                                    <Button
                                      color="primary"
                                      className="me-2"
                                      onClick={handleFeatureAddRow}
                                      disabled={index !== feature.length - 1}
                                    >
                                      +
                                    </Button>
                                    {feature.length > 1 && (
                                      <Button
                                        color="danger"
                                        onClick={() =>
                                          handleFeatureRemoveRow(index)
                                        }
                                      >
                                        Remove
                                      </Button>
                                    )}
                                  </Col>
                                </Row>
                              </CSSTransition>
                            ))}
                          </TransitionGroup>
                        </FormGroup>
                      </Row>
                    </TabPane>
                  </TabContent>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane id="addproduct-general-info" tabId="5">

                      <Row>
                        {/* Dynamic table for combinations */}
                        {/* {variantData.length > 0 && ( */}
                        <div className="table-responsive mt-3">
                          <Table bordered className="table">
                            <thead className="table-light">
                              <tr>
                                <th className="text-center align-middle" style={{ width: '5%' }}>#</th>
                                <th className="align-middle" style={{ width: '18%' }}>Variant (Route Base) <span className="text-danger">*</span></th>
                                <th className="align-middle" style={{ width: '10%' }}>MRP <span className="text-danger">*</span></th>
                                <th className="align-middle" style={{ width: '18%' }}>Offer Details</th>
                                <th className="align-middle" style={{ width: '12%' }}>Selling Price</th>
                                <th className="align-middle bg-light-subtle" style={{ width: '8%' }}>Stock</th>
                                <th className="align-middle bg-light-subtle" style={{ width: '12%' }}>SKU</th>
                                <th className="text-center align-middle" style={{ width: '10%' }}>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {variantData?.map((combo, index) => (
                                <React.Fragment key={index}>
                                  <tr className={index % 2 === 0 ? 'bg-white' : 'bg-light'}>
                                    {/* Serial Number */}
                                    <td rowSpan={2} className="text-center align-middle fw-bold border-bottom-0">{index + 1}</td>

                                    {/* Variant Details */}
                                    <td className="align-middle">
                                      <div className="d-flex flex-column gap-2">
                                        <div className="d-flex align-items-center gap-2">
                                          <div style={{ minWidth: '80px' }}>
                                            <Input
                                              type="text"
                                              value={combo.variant_value}
                                              onChange={(e) => handleCombinationChange(index, "variant_value", e.target.value)}
                                              className={`form-control form-control-sm ${validation.errors.variantData?.[index]?.variant_value &&
                                                validation.touched.variantData?.[index]?.variant_value ? "is-invalid" : ""}`}
                                              placeholder="Qty"
                                            />
                                          </div>
                                          <div style={{ minWidth: '100px' }}>
                                            <select
                                              className={`form-select form-select-sm ${validation.errors.variantData?.[index]?.variant_id &&
                                                validation.touched.variantData?.[index]?.variant_id ? "is-invalid" : ""}`}
                                              value={combo.variant_id}
                                              onChange={(e) => handleCombinationChange(index, "variant_id", e.target.value)}
                                            >
                                              <option value="">Select Unit</option>
                                              {availableVariants?.map((variant) => (
                                                <option key={variant.id} value={variant.id}>
                                                  {variant.name}
                                                </option>
                                              ))}
                                            </select>
                                          </div>

                                        </div>
                                        {(validation.errors.variantData?.[index]?.variant_id ||
                                          validation.errors.variantData?.[index]?.variant_value) && (
                                            <div className="alert alert-danger p-1 mb-0 text-center small">
                                              {validation.errors.variantData[index]?.variant_id ||
                                                validation.errors.variantData[index]?.variant_value}
                                            </div>
                                          )}
                                      </div>
                                    </td>

                                    {/* MRP */}
                                    <td className="align-middle">
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-light">₹</span>
                                        <Input
                                          type="number"
                                          value={combo.mrp}
                                          onChange={(e) => handleCombinationChange(index, "mrp", e.target.value)}
                                          className={`form-control ${validation.errors.variantData?.[index]?.mrp &&
                                            validation.touched.variantData?.[index]?.mrp ? "is-invalid" : ""}`}
                                          style={{ fontWeight: 'bold' }}
                                        />
                                      </div>
                                      {validation.errors.variantData?.[index]?.mrp &&
                                        validation.touched.variantData?.[index]?.mrp && (
                                          <div className="alert alert-danger p-1 mb-0 text-center small mt-1">
                                            {validation.errors.variantData[index].mrp}
                                          </div>
                                        )}
                                    </td>

                                    {/* Offer Details */}
                                    <td className="align-middle">
                                      <div className="d-flex flex-column gap-2">
                                        <div className="d-flex justify-content-center gap-2">
                                          <Button
                                            color={Number(combo.offer_type) === 1 ? "primary" : "outline-primary"}
                                            className={`btn-sm ${Number(combo.offer_type) === 1 ? 'active' : ''}`}
                                            onClick={() => {
                                              const newType = Number(combo.offer_type) === 1 ? 0 : 1;
                                              handleCombinationChange(index, "offer_type", newType);
                                            }}
                                            size="sm"
                                          >
                                            <i className="ri-money-rupee-circle-fill me-1"></i> Amount
                                          </Button>
                                          <Button
                                            color={Number(combo.offer_type) === 2 ? "primary" : "outline-primary"}
                                            className={`btn-sm ${Number(combo.offer_type) === 2 ? 'active' : ''}`}
                                            onClick={() => {
                                              const newType = Number(combo.offer_type) === 2 ? 0 : 2;
                                              handleCombinationChange(index, "offer_type", newType);
                                            }}
                                            size="sm"
                                          >
                                            <i className="ri-percent-fill me-1"></i> Percent
                                          </Button>
                                        </div>

                                        <Input
                                          type="number"
                                          className={`form-control-sm ${combo.offer_type ? 'border-success' : ''}`}
                                          value={combo.offer_value}
                                          onChange={(e) => handleCombinationChange(index, "offer_value", e.target.value)}
                                          placeholder={combo.offer_type === 1 ? "Discount amount" : "Discount %"}
                                          style={{ borderWidth: '2px', fontWeight: '500' }}
                                        />

                                        {combo.offer_value > 0 && (
                                          <div className="alert alert-success p-1 mb-0 text-center small">
                                            <i className="ri-checkbox-circle-fill me-1"></i>
                                            -₹{
                                              (
                                                combo.offer_type === 1
                                                  ? parseFloat(combo.offer_value || "0")
                                                  : combo.offer_type === 2
                                                    ? (parseFloat(combo.mrp || "0") * parseFloat(combo.offer_value || "0")) / 100
                                                    : 0
                                              ).toFixed(2)
                                            }
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    {/* Selling Price */}
                                    <td className="align-middle">
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-light">₹</span>
                                        <Input
                                          type="number"
                                          value={combo.actual_amount}
                                          onChange={(e) => handleCombinationChange(index, "actual_amount", e.target.value)}
                                          className={`form-control bg-light ${validation.errors.variantData?.[index]?.actual_amount &&
                                            validation.touched.variantData?.[index]?.actual_amount ? "is-invalid" : ""}`}
                                          style={{ fontWeight: 'bold' }}
                                          readOnly={combo.offer_type > 0}
                                        />
                                      </div>
                                      {validation.errors.variantData?.[index]?.actual_amount &&
                                        validation.touched.variantData?.[index]?.actual_amount && (
                                          <div className="alert alert-danger p-1 mb-0 text-center small mt-1">
                                            {validation.errors.variantData[index].actual_amount}
                                          </div>
                                        )}
                                    </td>

                                    {/* Stock */}
                                    <td className="align-middle">
                                      <Input
                                        type="number"
                                        value={combo.stock}
                                        onChange={(e) => handleCombinationChange(index, "stock", e.target.value)}
                                        className={`form-control form-control-sm ${validation.errors.variantData?.[index]?.stock &&
                                          validation.touched.variantData?.[index]?.stock ? "is-invalid" : ""}`}
                                        min="0"
                                      />
                                    </td>

                                    {/* SKU */}
                                    <td className="align-middle">
                                      <Input
                                        value={combo.sku}
                                        onChange={(e) => handleCombinationChange(index, "sku", e.target.value)}
                                        className={`form-control form-control-sm ${validation.errors.variantData?.[index]?.sku &&
                                          validation.touched.variantData?.[index]?.sku ? "is-invalid" : ""}`}
                                        placeholder="SKU ID"
                                      />
                                    </td>

                                    {/* Actions (Rowspan 2) */}
                                    <td rowSpan={2} className="text-center align-middle">
                                      <div className="d-flex justify-content-center gap-2">
                                        {index === variantData?.length - 1 && (
                                          <Button
                                            color="success"
                                            size="sm"
                                            className="btn-icon rounded-circle"
                                            onClick={handleAddRow}
                                            title="Add new variant"
                                          >
                                            <i className="ri-add-line"></i>
                                          </Button>
                                        )}
                                        {variantData?.length > 1 && (
                                          <Button
                                            color="danger"
                                            size="sm"
                                            className="btn-icon rounded-circle"
                                            onClick={() => handleRemoveRow(index)}
                                            title="Remove variant"
                                          >
                                            <i className="ri-delete-bin-line"></i>
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>

                                  {/* ROW 2 */}
                                  <tr className={index % 2 === 0 ? 'bg-white' : 'bg-light'}>
                                    {/* Route Slots (colSpan 6) */}
                                    <td colSpan={6} className="py-2 border-top-0 px-1">
                                      <div className="col-10 mx-auto">
                                        <div className="p-3 border rounded shadow-sm" style={{ backgroundColor: '#fdfdfd' }}>
                                          <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                            <div className="d-flex align-items-center gap-2">
                                              <div className="bg-primary bg-opacity-10 p-2 rounded">
                                                <i className="ri-road-map-line text-primary fs-18"></i>
                                              </div>
                                              <div>
                                                <h6 className="mb-0 fw-bold text-primary">Assign Routes</h6>
                                                <small className="text-muted">Select routes where this variant is available</small>
                                              </div>
                                            </div>
                                            {availableRoutes?.length > 0 && (
                                              <div className="form-check form-switch card-radio mt-0 pointer">
                                                <Input
                                                  type="checkbox"
                                                  className="form-check-input mt-0"
                                                  id={`select-all-routes-${index}`}
                                                  checked={combo.route_slots?.length === availableRoutes.length && availableRoutes.length > 0}
                                                  onChange={(e) => {
                                                    if (e.target.checked) {
                                                      const allRoutes = availableRoutes.map(r => ({ label: r.name, value: r.id }));
                                                      handleCombinationChange(index, "route_slots", allRoutes);
                                                    } else {
                                                      handleCombinationChange(index, "route_slots", []);
                                                    }
                                                  }}
                                                  style={{ cursor: 'pointer' }}
                                                />
                                                <Label className="form-check-label fw-bold small ms-2 mb-0" htmlFor={`select-all-routes-${index}`} style={{ cursor: 'pointer' }}>
                                                  Select All Routes ({combo.route_slots?.length || 0}/{availableRoutes.length})
                                                </Label>
                                              </div>
                                            )}
                                          </div>

                                          <div className="row g-2 overflow-auto" style={{ maxHeight: '180px' }}>
                                            {(availableRoutes || []).map((route: any, routeIdx: number) => {
                                              const isChecked = combo.route_slots?.some((rs: any) => rs.value === route.id);
                                              return (
                                                <div key={route.id} className="col-xl-3 col-lg-4 col-sm-6">
                                                  <div className={`form-check p-0 m-0 w-100`}>
                                                    <Input
                                                      type="checkbox"
                                                      className="btn-check"
                                                      id={`route-${route.id}-${index}`}
                                                      checked={isChecked}
                                                      onChange={(e) => {
                                                        let updatedSlots = [...(combo.route_slots || [])];
                                                        if (e.target.checked) {
                                                          updatedSlots.push({ label: route.name, value: route.id });
                                                        } else {
                                                          updatedSlots = updatedSlots.filter((rs: any) => rs.value !== route.id);
                                                        }
                                                        handleCombinationChange(index, "route_slots", updatedSlots);
                                                      }}
                                                    />
                                                    <Label
                                                      className={`btn ${isChecked ? 'btn-success bg-opacity-10 text-success border-success' : 'btn-outline-secondary opacity-75'} btn-sm w-100 text-start d-flex align-items-center justify-content-between p-2 mb-0 border-2 rounded-3 transition-all fw-bold`}
                                                      htmlFor={`route-${route.id}-${index}`}
                                                      style={{
                                                        transition: 'all 0.2s ease',
                                                        backgroundColor: isChecked ? '#e6fffa' : 'transparent'
                                                      }}
                                                    >
                                                      <span className="text-truncate">
                                                        <span className="me-1">{routeIdx + 1}.</span>
                                                        <i className={`${isChecked ? 'ri-checkbox-circle-fill' : 'ri-checkbox-blank-circle-line'} me-2 fs-14`}></i>
                                                        {route.name}
                                                      </span>
                                                     </Label>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>

                                          {(!availableRoutes || availableRoutes.length === 0) && (
                                            <div className="text-center py-4 bg-light rounded-3 border-dashed">
                                              <i className="ri-map-pin-line fs-24 text-muted mb-2 d-block"></i>
                                              <span className="text-muted fw-medium">No routes available. Please create routes first.</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                        {/* // )} */}
                      </Row>

                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {validation.errors &&
            typeof validation.errors === 'object' &&
            !Array.isArray(validation.errors) &&
            Object.keys(validation.errors).length > 0 && (
              <div className="row justify-content-center mt-3">
                <div className="col-md-7">
                  <div className="card text-center bg-light border border-danger">
                    <div className="card-body">
                      {Object.values(validation.errors as Record<string, unknown>).map((err, index) => {
                        if (typeof err === 'string') {
                          return (
                            <p key={index} style={{ color: 'red' }}>
                              {err}
                            </p>
                          );
                        }

                        if (Array.isArray(err)) {
                          return err?.map((nestedObj, subIndex) =>
                            nestedObj && typeof nestedObj === 'object'
                              ? Object.entries(nestedObj as Record<string, string>).map(
                                ([key, value], innerIndex) => (
                                  <p key={`${index}-${subIndex}-${innerIndex}`} style={{ color: 'red' }}>
                                    {value}
                                  </p>
                                )
                              )
                              : null
                          );
                        }

                        if (typeof err === 'object' && err !== null) {
                          return Object.values(err as Record<string, string>).map((value, subIndex) => (
                            <p key={`${index}-${subIndex}`} style={{ color: 'red' }}>
                              {value}
                            </p>
                          ));
                        }

                        return null;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}


          <div className="text-end mb-3">
            <button type="submit" className="btn btn-success w-sm">
              Submit
            </button>
          </div>
        </Form>
        <Modal isOpen={isModalOpen} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Add New Variant</ModalHeader>
          <ModalBody>
            <Label for="variantName">Variant Name</Label>
            <Input
              type="text"
              id="variantName"
              placeholder="Enter variant name"
              value={newVariant}
              onChange={(e) => {
                setNewVariant(e.target.value);
                setVaraiantError("");
              }}
            />
            {(varaiantError || newVariant === "") && (
              <span className="text-danger">{varaiantError}</span>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>
              Discard
            </Button>
            <Button color="primary" onClick={handleSave}>
              Save
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={isCategoryModal} toggle={toggleCategoryModal}>
          <ModalHeader toggle={toggleCategoryModal}>
            Add New Category
          </ModalHeader>
          <ModalBody>
            <div>
              <Label for="categoryName">Category Name</Label>
              <Input
                type="text"
                id="categoryName"
                placeholder="Enter category name"
                value={newCategory}
                onChange={(e) => {
                  setNewCategory(e.target.value);
                  setCategoryError("");
                }}
              />
              {/* Display error message */}
              {(categoryError || newCategory === "") && (
                <span className="text-danger">{categoryError}</span>
              )}
            </div>

            <Label className="mt-3">Parent Category (Optional)</Label>
            <Select
              value={selectedParentCategory}
              onChange={(option: any) =>
                setSelectedParentCategory(option as CategoryOption)
              }
              options={availableCategories?.map((spec) => ({
                label: spec.name,
                value: spec.id,
              }))}
              placeholder="Select Parent Category "
              isClearable
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleCategoryModal}>
              Discard
            </Button>
            <Button color="primary" onClick={handleCategory}>
              Save
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={isSpecificationModal} toggle={toggleSpecificationModal}>
          <ModalHeader toggle={toggleSpecificationModal}>
            Add New Specification
          </ModalHeader>
          <ModalBody>
            <div>
              <Label for="SpecificationName">Specification Name</Label>
              <Input
                type="text"
                id="SpecificationName"
                placeholder="Enter specification name"
                value={newSpecification}
                onChange={(e) => {
                  setNewSpecification(e.target.value);
                  setSpecificationError("");
                }}
              />
              {/* Display error message */}
              {(specificationError || newSpecification === "") && (
                <span className="text-danger">{specificationError}</span>
              )}
            </div>

            <Label className="mt-3">Parent Specification (Optional)</Label>
            <Select
              value={selectedParentSpecification}
              onChange={(option: any) =>
                setSelectedParentSpecification(option as SpecificationOption)
              }
              options={availableSpecification?.map((spec) => ({
                label: spec.name,
                value: spec.id,
              }))}
              placeholder="Select Parent Specification "
              isClearable
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleSpecificationModal}>
              Discard
            </Button>
            <Button color="primary" onClick={handleSpecification}>
              Save
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={isFeatureModal} toggle={toggleFeatureModal}>
          <ModalHeader toggle={toggleFeatureModal}>Add New Feature</ModalHeader>
          <ModalBody>
            <div>
              <Label for="FeatureName">Feature Name</Label>
              <Input
                type="text"
                id="FeatureName"
                placeholder="Enter feature name"
                value={newFeature}
                onChange={(e) => {
                  setNewFeature(e.target.value);
                  setFeatureError("");
                }}
              />
              {/* Display error message */}
              {(featureError || newFeature === "") && (
                <span className="text-danger">{featureError}</span>
              )}
            </div>

            <Label className="mt-3">Parent Feature (Optional)</Label>
            <Select
              value={selectedParentFeature}
              onChange={(option: any) =>
                setSelectedParentFeature(option as FeatureOption)
              }
              options={availableFeature?.map((spec) => ({
                label: spec.name,
                value: spec.id,
              }))}
              placeholder="Select Parent Feature "
              isClearable
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleFeatureModal}>
              Discard
            </Button>
            <Button color="primary" onClick={handleFeature}>
              Save
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={isBrandModal} toggle={toggleBrandModal}>
          <ModalHeader toggle={toggleBrandModal}>Add Brand</ModalHeader>
          <ModalBody>
            <div className="text-center">
              <div className="position-relative d-inline-block">
                <div>
                  Brand Logo <span className="text-danger">*</span>
                </div>
                <div className="position-absolute  bottom-0 end-0">
                  <Label htmlFor="product-image-input" className="mb-0">
                    <div className="avatar-xs cursor-pointer">
                      <div className="avatar-title bg-light border rounded-circle text-muted">
                        <i className="ri-image-fill"></i>
                      </div>
                    </div>
                  </Label>
                  <Input
                    name="brandImage"
                    className="form-control d-none"
                    id="product-image-input"
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    onChange={(e) => handleImageChange(e, "modalImage")}
                  />
                </div>
                <div className="avatar-lg p-1">
                  <div className="avatar-title bg-light rounded-circle">
                    <img
                      src={previewBrandImage || dummyImg}
                      alt="dummyImg"
                      id="customer-img"
                      className="avatar-md rounded-circle object-fit-cover"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Label for="BrandName">Brand Name</Label>
              <Input
                type="text"
                id="BrandName"
                placeholder="Enter brand name"
                value={newBrand}
                onChange={(e) => {
                  setNewBrand(e.target.value);
                  setBrandError(""); // Clear error when typing
                }}
              />
              {/* Display error message */}
              {BrandError && <span className="text-danger">{BrandError}</span>}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleBrandModal}>
              Discard
            </Button>
            <Button color="primary" onClick={handleBrand}>
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default EditProduct;
